import { useDecision } from '@optimizely/react-sdk';

const useFeatureFlag = (flagKey: string) => {
  const [decision, isReady] = useDecision(flagKey);

  return {
    isReady,
    isEnabled: decision?.enabled ?? false,
  };
};

export default useFeatureFlag;
